import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  employeeFormLabel,
  employeeMedicalCategoryObj,
  employeeMedicalEligibilityObj,
  employeeMineTagObj,
  employeeTrainingEligibilityObj,
} from "../Constant";
import { siteTypeObj } from "app/_pages/_globalConfiguration/HealthSafetyEnvironment/Sites/Sites";
import { contractorPersonFormLabel } from "../../ContractorPerson/Constant";

function ViewLocationForm({ form, isContractorPerson }) {
  return (
    <div>
      <h5>Current Location</h5>
      <Row>
        {isContractorPerson && (
          <Col md={4}>
            <h5>{contractorPersonFormLabel["contractorId"]}</h5>
            <p>{form?.contractors?.contractorLegalEntity}</p>
          </Col>
        )}
        <Col md={4}>
          <h5>{employeeFormLabel["siteType"]}</h5>
          <p>{siteTypeObj[form?.siteType]}</p>
        </Col>
        <Col md={4}>
          <h5>{employeeFormLabel["currentWorkLocation"]}</h5>
          <p>{form?.ehsSite?.name}</p>
        </Col>
        <Col md={isContractorPerson ? 4 : 3}>
          <h5>{employeeFormLabel["startDateAtMines"]}</h5>
          <p>{form?.startDateAtMines ? DDMMYYYYFormat(form?.startDateAtMines) : ""}</p>
        </Col>
        <Col md={1}>
          <h5>{employeeFormLabel["mineTag"]}</h5>
          <p>{employeeMineTagObj[form?.mineTag]}</p>
        </Col>
      </Row>
      {form?.siteType === 3 && (
        <>
          <h5>Training</h5>
          <Row>
            <Col md={4}>
              <h5>{employeeFormLabel["trainingEligibility"]}</h5>
              <p>{employeeTrainingEligibilityObj[form?.trainingEligibility]}</p>
            </Col>
            <Col md={4}>
              <h5>{employeeFormLabel["trainingDesignation"]}</h5>
              <p>{form?.trainingDesignationData?.name}</p>
            </Col>
          </Row>
          <h5>Medical</h5>
          <Row>
            <Col md={4}>
              <h5>Is Last PME Date Available</h5>
              <p>{form.isPmeDate ? "Yes" : "No"}</p>
            </Col>
            <Col md={4}>
              <h5>{employeeFormLabel["pmeDate"]}</h5>
              <p>{form?.pmeDate ? DDMMYYYYFormat(form?.pmeDate) : ""}</p>
            </Col>
            <Col md={4}>
              <h5>{employeeFormLabel["pmeCertificateNo"]}</h5>
              <p>{form?.pmeCertificateNo}</p>
            </Col>
            <Col md={4}>
              <h5>{employeeFormLabel["specialMedicalExamEligibility"]}</h5>
              <p>{employeeMedicalEligibilityObj[form?.specialMedicalExamEligibility]}</p>
            </Col>
            <Col md={4}>
              <h5>{employeeFormLabel["specialMedicalExamCategory"]}</h5>
              <p>{employeeMedicalCategoryObj[form?.specialMedicalExamCategory]}</p>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
}

export default ViewLocationForm;
